import { render } from "./TaskModul.vue?vue&type=template&id=06008c16"
import script from "./TaskModul.vue?vue&type=script&lang=js"
export * from "./TaskModul.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__